import React, {useState} from 'react';
import {Button, Icon} from "../../../../../../components/Component";
import {FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import Axios from "axios";
import API_ROUTES from "../../../../../../config/api";
import {Auth} from "aws-amplify";

const AuthoriseButton = ({ triggerReload, item }) => {
  const [modalForm, setModalForm] = useState(false);
  const [modalFormProcessing, setModalFormProcessing] = useState(false);

  const toggleForm = () => setModalForm(!modalForm);

  const authoriseRefund = async () => {
    setModalFormProcessing(true);
    const authUser = await Auth.currentAuthenticatedUser();

    await Axios(
      API_ROUTES.agent['refund:authorise'](item.authorisation_code),
      {
        method: 'get',
        headers: { Authorization: `Bearer ${authUser.signInUserSession.idToken.jwtToken}` },
      }
    );

    triggerReload();
    toggleForm();
    setModalFormProcessing(false);
  };

  return (
    <React.Fragment>
      <Button
        className="bg-emerald-600 hover:bg-emerald-800 text-white w-100 text-center"
        onClick={toggleForm}
        style={{ display: 'block' }}>Authorise</Button>

      <Modal isOpen={modalForm} toggle={toggleForm}>
        <ModalHeader
          toggle={toggleForm}
          className="bg-emerald-600 text-white text-lg"
          close={
            <button className="close" onClick={toggleForm}>
              <Icon name="cross" className="text-white" />
            </button>
          }
        >
          Authorise Refund
        </ModalHeader>
        <ModalBody>
          <p>Are you sure that you would like to authorise this refund?</p>
        </ModalBody>
        <ModalFooter className="bg-light">
          <FormGroup>
            <Button className="bg-emerald-600 hover:bg-emerald-800 text-white" type="submit" disabled={modalFormProcessing} onClick={
              (ev) => {
                ev.preventDefault();
                authoriseRefund();
              }
            } size="lg">
              {modalFormProcessing ? <Spinner size="sm" color="light"> </Spinner> : 'Continue'}
            </Button>
          </FormGroup>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default AuthoriseButton;
